<template>
    <DModal
        :id="mailModalId"
        :show="showModal"
        :title="__('messages.preview_text')"
        is-big
        overflow-auto
        @close="closeModal"
    >
        <div
            id="mailBody"
            class="p-4"
        >
            <div v-if="isHtml">
                <p v-html="content" />
            </div>
            <div v-else>
                <span class="non-html">{{ content }}</span>
            </div>
            <p
                v-for="(error, index) in errors"
                :key="index"
                class="help-block text-danger"
            >
                {{ error }}
            </p>
        </div>
    </DModal>
</template>

<script>
/* eslint vue/no-v-html: 0 */
import preventEmailUrl from '~@/Mixins/preventEmailUrl'
export default {
    name: 'PreviewTextModal',
    mixins: [
        preventEmailUrl
    ],
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        content: {
            type: String,
            default: ''
        },
        isHtml: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
            default: () => []
        }
    },
    emits: ['modalClosed'],
    data () {
        return {
            mailModalId: 'mailModal'
        }
    },
    updated () {
        this.preventEmailUrl(this.mailModalId)
    },
    methods: {
        closeModal () {
            this.$emit('modalClosed')
        }
    }
}
</script>

<style lang="scss" scoped>
.non-html {
    font-family: monospace, monospace;
    white-space: pre-wrap;
}
</style>
